<script setup lang="ts">
import LoadingButton from "./general/LoadingButton.vue";
import { startLogout } from "@/lib/auth";
import { ref } from "vue";
import { DialogClose, DialogTitle } from "reka-ui";

const loading = ref(false);

const handleLogout = () => {
  loading.value = true;
  startLogout();
};
</script>

<template>
  <div class="p-4 w-full">
    <DialogTitle class="text-xl font-bold mb-6">{{
      $t("logout_modal.title")
    }}</DialogTitle>
    <div class="grid grid-cols-2 gap-3">
      <DialogClose class="btn-secondary">
        {{ $t("common.cancel") }}
      </DialogClose>
      <LoadingButton @click="handleLogout" :loading="loading">
        {{ $t("logout_modal.logout_button") }}
      </LoadingButton>
    </div>
  </div>
</template>
